import axios from 'axios';
import { API_BASE_URL_V2 } from '../config/apiConfig';

// Create axios instance for v2 API (paperback APIs)
const axiosV2 = axios.create({
  baseURL: API_BASE_URL_V2,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to v2 requests if available
if (localStorage.jwtToken) {
  axiosV2.defaults.headers.common['x-access-token'] = localStorage.jwtToken;
}

// Interceptor to update token if it changes
axiosV2.interceptors.request.use(
  (config) => {
    const token = localStorage.jwtToken;
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosV2;
